/**
 * MailboxReconnectPage — schlichte, eigenständige Seite zum (Neu-)Verbinden der
 * geteilten E-Mail-Postfächer über Google OAuth.
 *
 * Erreichbar unter /mail-verbinden (siehe App.tsx + navigation.ts).
 * Lade-/Fehlerzustände werden je Karte in MailboxConnectionCard behandelt.
 */

import { Mail, Inbox, Wrench } from 'lucide-react';
import { MailboxConnectionCard } from '@/components/MailboxConnectionCard';

const ACCENT = '#9B1C1C';

export default function MailboxReconnectPage() {
  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-6">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-gray-900">E-Mail-Postfächer verbinden</h1>
        <p className="text-sm text-gray-500 mt-1">
          Verbinde oder erneuere die Verbindung der geteilten Postfächer mit Google.
          Der echte Verbindungsstatus wird pro Postfach live geprüft.
        </p>
      </div>

      <div className="space-y-3">
        <MailboxConnectionCard
          email="forderungen@gutachter-koop.de"
          subtitle="Forderungen"
          oauthUserId="forderungen_gutachter_koop"
          icon={Inbox}
          accent="blue"
          roles={['Forderungsmanagement']}
        />
        <MailboxConnectionCard
          email="info@gutachter-koop.de"
          subtitle="Geteiltes Postfach — Gutachten"
          oauthUserId="info_gutachter_koop"
          icon={Mail}
          accent="blue"
          roles={['Gutachten', 'Zentrale']}
        />
        <MailboxConnectionCard
          email="info@lenneglas.de"
          subtitle="Autoglas"
          oauthUserId="info_lenneglas"
          icon={Wrench}
          accent="green"
          roles={['Autoglas']}
        />
      </div>

      <p className="text-[11px] text-gray-400 mt-5" style={{ borderLeft: `3px solid ${ACCENT}`, paddingLeft: 8 }}>
        Beim Verbinden wirst du zu Google weitergeleitet. Melde dich dort mit dem
        jeweils angezeigten Postfach an.
      </p>
    </div>
  );
}
